<div class="page-content container">
  <div class="page-header">
    <h1>{{ translationManager.getTranslation('Преглед потврђених ставки набавке') }}</h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info"><span><i class="fa fa-info-circle"></i>{{
          translationManager.getTranslation('Страница за преглед потврђених ставки набавке') }}</span>
      </div>
    </div>
    <div class="app-table-panel" app-table>
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Назив ставке')">
                  {{translationManager.getTranslation('Назив ставке')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Статус ставке')">
                  {{translationManager.getTranslation('Статус ставке')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Број уговора/поруџбенице')">
                  {{translationManager.getTranslation('Број уговора/поруџбенице')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Вредност поруџбенице')">
                  {{translationManager.getTranslation('Вредност поруџбенице')}}
                </a>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>{{item.ticketItemName}}</td>
              <td>{{item.ticketItemStatusName}}</td>
              <td>{{item.contractNumber}}</td>
              <td>{{item.contractValue}}</td>
            </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>
    </div>
    <div class="app-form-element-buttons">
      <button class="btn btn-warning fl amno" (click)="navigateToBack()">
        <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
    </div>
  </div>
</div>
